var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initialized)?_c('BasePageContainer',{staticClass:"pt-6"},[_c('page-header',{attrs:{"has-back":""}},[_vm._v(" 予定編集 ")]),_c('event-form',{attrs:{"event":_vm.event,"is-edit":""},on:{"submit":_vm.updateEvent}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }